module.exports = __webpack_public_path__ + "static/media/slant.5db3b34c.svg";